var Variables = (function(){

  var varObject = {
    desktopLarge:  1280,
    desktop:       1024,
    tabletLarge:   992,
    tablet:        767,
    mobileLarge:   480,
    mobile:        320,
    headerHeight:  $('[data-site-header]').outerHeight(),
    sectionMenuHeight: $('[data-section-nav]').outerHeight()
  }

	return varObject 

}());